export type GeoCtaType =
  | "none"
  | "birthday"
  | "wishlist"
  | "community"
  | "checkout"
  | "mejores_amigos";

export const DEFAULT_AR_CTA: GeoCtaType = "none";
export const DEFAULT_COUNTRY_CTA: GeoCtaType = "none";

export const AR_PROVINCES: { code: string; name: string; region: string }[] = [
  { code: "CABA", name: "CABA", region: "CABA" },
  { code: "Buenos Aires", name: "Buenos Aires", region: "GBA" },
  { code: "Córdoba", name: "Córdoba", region: "Centro" },
  { code: "Santa Fe", name: "Santa Fe", region: "Centro" },
  { code: "Mendoza", name: "Mendoza", region: "Cuyo" },
  { code: "Tucumán", name: "Tucumán", region: "NOA" },
  { code: "Entre Ríos", name: "Entre Ríos", region: "Litoral" },
  { code: "Salta", name: "Salta", region: "NOA" },
  { code: "Misiones", name: "Misiones", region: "NEA" },
  { code: "Chaco", name: "Chaco", region: "NEA" },
  { code: "Corrientes", name: "Corrientes", region: "NEA" },
  { code: "Santiago del Estero", name: "Santiago del Estero", region: "NOA" },
  { code: "San Juan", name: "San Juan", region: "Cuyo" },
  { code: "Jujuy", name: "Jujuy", region: "NOA" },
  { code: "Río Negro", name: "Río Negro", region: "Patagonia" },
  { code: "Neuquén", name: "Neuquén", region: "Patagonia" },
  { code: "Formosa", name: "Formosa", region: "NEA" },
  { code: "Chubut", name: "Chubut", region: "Patagonia" },
  { code: "San Luis", name: "San Luis", region: "Cuyo" },
  { code: "Catamarca", name: "Catamarca", region: "NOA" },
  { code: "La Rioja", name: "La Rioja", region: "NOA" },
  { code: "Santa Cruz", name: "Santa Cruz", region: "Patagonia" },
  { code: "La Pampa", name: "La Pampa", region: "Patagonia" },
  { code: "Tierra del Fuego", name: "Tierra del Fuego", region: "Patagonia" },
];

export const AR_TOP_CITIES: { name: string; province: string }[] = [
  // "Buenos Aires" (city) = la capital (provincia CABA). Es la key canónica a
  // la que el Worker resuelve todas las variantes de cf.city ("Capital
  // Federal", "CABA", "Ciudad de Buenos Aires", …) vía WORKER_CITY_ALIASES.
  // NO agregar esas variantes como cities separadas: generan entries duplicadas
  // para el mismo pool de visitantes (el resolver toma la primera que matchea).
  { name: "Buenos Aires", province: "CABA" },
  { name: "Avellaneda", province: "Buenos Aires" },
  { name: "Lanús", province: "Buenos Aires" },
  { name: "Lomas de Zamora", province: "Buenos Aires" },
  { name: "Quilmes", province: "Buenos Aires" },
  { name: "San Isidro", province: "Buenos Aires" },
  { name: "Vicente López", province: "Buenos Aires" },
  { name: "Tigre", province: "Buenos Aires" },
  { name: "Tres de Febrero", province: "Buenos Aires" },
  { name: "General San Martín", province: "Buenos Aires" },
  { name: "Morón", province: "Buenos Aires" },
  { name: "Hurlingham", province: "Buenos Aires" },
  { name: "La Matanza", province: "Buenos Aires" },
  { name: "San Justo", province: "Buenos Aires" },
  { name: "Pilar", province: "Buenos Aires" },
  { name: "Tortuguitas", province: "Buenos Aires" },
  { name: "Malvinas Argentinas", province: "Buenos Aires" },
  { name: "José C. Paz", province: "Buenos Aires" },
  { name: "Moreno", province: "Buenos Aires" },
  { name: "Berazategui", province: "Buenos Aires" },
  { name: "Florencio Varela", province: "Buenos Aires" },
  { name: "Almirante Brown", province: "Buenos Aires" },
  { name: "Esteban Echeverría", province: "Buenos Aires" },
  { name: "Ezeiza", province: "Buenos Aires" },
  { name: "La Plata", province: "Buenos Aires" },
  { name: "Mar del Plata", province: "Buenos Aires" },
  { name: "Bahía Blanca", province: "Buenos Aires" },
  { name: "Chivilcoy", province: "Buenos Aires" },
  { name: "Mercedes", province: "Buenos Aires" },
  { name: "Junín", province: "Buenos Aires" },
  { name: "Chascomús", province: "Buenos Aires" },
  { name: "Tandil", province: "Buenos Aires" },
  { name: "Olavarría", province: "Buenos Aires" },
  { name: "Necochea", province: "Buenos Aires" },
  { name: "Pergamino", province: "Buenos Aires" },
  { name: "Santa Teresita", province: "Buenos Aires" },
  { name: "Pinamar", province: "Buenos Aires" },
  { name: "Villa Gesell", province: "Buenos Aires" },
  { name: "Córdoba", province: "Córdoba" },
  { name: "Carlos Paz", province: "Córdoba" },
  { name: "Río Cuarto", province: "Córdoba" },
  { name: "Rosario", province: "Santa Fe" },
  { name: "Santa Fe", province: "Santa Fe" },
  { name: "Rafaela", province: "Santa Fe" },
  { name: "Mendoza", province: "Mendoza" },
  { name: "San Rafael", province: "Mendoza" },
  { name: "San Miguel de Tucumán", province: "Tucumán" },
  { name: "Salta", province: "Salta" },
  { name: "San Salvador de Jujuy", province: "Jujuy" },
  { name: "Resistencia", province: "Chaco" },
  { name: "Posadas", province: "Misiones" },
  { name: "Corrientes", province: "Corrientes" },
  { name: "Paraná", province: "Entre Ríos" },
  { name: "Concordia", province: "Entre Ríos" },
  { name: "Gualeguaychú", province: "Entre Ríos" },
  { name: "Neuquén", province: "Neuquén" },
  { name: "Bariloche", province: "Río Negro" },
  { name: "San Carlos de Bariloche", province: "Río Negro" },
  { name: "Viedma", province: "Río Negro" },
  { name: "San Juan", province: "San Juan" },
  { name: "San Luis", province: "San Luis" },
  { name: "La Rioja", province: "La Rioja" },
  { name: "Catamarca", province: "Catamarca" },
  { name: "Santiago del Estero", province: "Santiago del Estero" },
  { name: "Santa Rosa", province: "La Pampa" },
  { name: "Comodoro Rivadavia", province: "Chubut" },
  { name: "Trelew", province: "Chubut" },
  { name: "Puerto Madryn", province: "Chubut" },
  { name: "Río Gallegos", province: "Santa Cruz" },
  { name: "Ushuaia", province: "Tierra del Fuego" },
  { name: "Río Grande", province: "Tierra del Fuego" },
  { name: "Formosa", province: "Formosa" },
];